var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "header-steps" }, [
        _c("strong", [
          _vm._v(
            "Etapa " +
              _vm._s(_vm.nRootSteps) +
              " de " +
              _vm._s(_vm.nRootSteps) +
              " - Resumo do combo"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-label" }, [
        _c("div", [
          _c("div", { staticStyle: { "font-size": "14px" } }, [
            _c("i", { staticClass: "fa-regular fa-user" }),
            _vm._v("  \n        "),
            _c("strong", [_vm._v(_vm._s(_vm.$props.nomeItem.toUpperCase()))]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.prices, function (price) {
        return _c("div", { key: price.id, staticClass: "faixa-option" }, [
          _c("div", { staticClass: "faixa-option-info" }, [
            _c("strong", [_vm._v(_vm._s(price.faixa_nome))]),
            _c("br"),
            _vm._v(" "),
            _c("span", [_vm._v("(" + _vm._s(price.faixa_descricao) + ")")]),
            _c("br"),
            _vm._v(" "),
            price.precoDe
              ? _c(
                  "span",
                  {
                    staticStyle: {
                      color: "lightgray",
                      "text-decoration": "line-through",
                    },
                  },
                  [_vm._v(_vm._s(_vm.formatMoney(price.precoDe)) + " ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("strong", { style: { color: _vm.primaryColor } }, [
              _vm._v(_vm._s(_vm.formatMoney(price.preco))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "faixa-option-quantity-display",
              attrs: { translate: "no" },
            },
            [_c("strong", [_vm._v("x" + _vm._s(price.quantidade))])]
          ),
        ])
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.activities, function (ac) {
        return _c("div", { key: ac.id, staticClass: "faixa-option" }, [
          _c("div", { staticClass: "faixa-option-info" }, [
            _c("strong", [_vm._v(_vm._s(ac.nome))]),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.formatDate(ac.selectedDay)) +
                  " | " +
                  _vm._s(
                    ac.selectedAvailability ? ac.selectedAvailability.label : ""
                  )
              ),
            ]),
            _c("br"),
          ]),
        ])
      }),
      _vm._v(" "),
      _vm.groupedOptionals.length > 0
        ? _c("div", { staticClass: "header-label mt-3" }, [_vm._m(1)])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.groupedOptionals, function (op) {
        return _c("div", { key: op.id, staticClass: "faixa-option" }, [
          _c("div", { staticClass: "faixa-option-info" }, [
            _c("strong", [_vm._v(_vm._s(op.nome))]),
            _c("br"),
            _vm._v(" "),
            _c("small", [_vm._v("Para: " + _vm._s(op.atividade))]),
            _c("br"),
            _vm._v(" "),
            _c("strong", { style: { color: _vm.primaryColor } }, [
              _vm._v(_vm._s(_vm.formatMoney(op.preco))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "faixa-option-quantity-display",
              attrs: { translate: "no" },
            },
            [_c("strong", [_vm._v("x" + _vm._s(op.quantidade))])]
          ),
        ])
      }),
      _vm._v(" "),
      _vm.hasScheduleConflicts
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger mt-2",
              attrs: { role: "alert" },
            },
            [
              _vm._v(
                "\n    Os horários selecionados estão em conflito, verifique nas etapas anteriores.\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("nav-buttons", {
        style: { "margin-top": _vm.isMobile ? "0px" : "20px" },
        attrs: {
          "disable-previus": false,
          "disable-next": _vm.disableFinish,
          "is-finish": true,
          "is-mobile": _vm.isMobile,
          moeda: _vm.moeda,
          "sub-total": _vm.subTotal,
        },
        on: { next: _vm.finish, previus: _vm.previus },
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-label mt-3" }, [
      _c("div", [
        _c("div", { staticStyle: { "font-size": "14px" } }, [
          _c("i", { staticClass: "fas fa-shopping-bag" }),
          _vm._v("  \n        "),
          _c("strong", [_vm._v("ITENS DO COMBO")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticStyle: { "font-size": "14px" } }, [
        _c("i", { staticClass: "fa-solid fa-star" }),
        _vm._v("  \n        "),
        _c("strong", [_vm._v("OPCIONAIS")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }